import { c as _c } from "react/compiler-runtime";
import { Link } from '@/components/Link';
import type { RecentSearchCarouselItem } from '@/components/blocks/cms/RecentSearchesBlock/types/RecentSearchCarouselItem';
import { CarouselSlide } from '@/components/carousel/CarouselSlide';
import { PhosphorIcon } from '@/components/icons/PhosphorIcon';
import analytics from '@/services/analytics';
export type RecentSearchSlideProps = {
  recentSearch: RecentSearchCarouselItem;
};
export function RecentSearchCarouselSlide(t0) {
  const $ = _c(17);
  const {
    recentSearch
  } = t0;
  let t1;
  if ($[0] !== recentSearch.suid) {
    t1 = () => {
      analytics.plugins.interactions.trackInteraction({
        source: "jucy-website",
        category: "recent-search",
        action: "view",
        label: recentSearch.suid
      });
    };
    $[0] = recentSearch.suid;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="basis-[60px]  flex items-center justify-center"><div className="bg-gray-100 rounded-full size-9 flex items-center justify-center"><PhosphorIcon className="text-[18px]" name="magnifying-glass" /></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== recentSearch.dropOffLocationName || $[4] !== recentSearch.pickUpLocationName) {
    t3 = <div className="text-sm font-semibold whitespace-nowrap overflow-hidden text-ellipsis mb-[6px]">{recentSearch.pickUpLocationName} → {recentSearch.dropOffLocationName}</div>;
    $[3] = recentSearch.dropOffLocationName;
    $[4] = recentSearch.pickUpLocationName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== recentSearch.dropOffDateFormatted || $[7] !== recentSearch.fleetTypeFormatted || $[8] !== recentSearch.pickUpDateFormatted) {
    t4 = <div className="text-xs whitespace-nowrap overflow-hidden text-ellipsis">{recentSearch.fleetTypeFormatted} • {recentSearch.pickUpDateFormatted} - {recentSearch.dropOffDateFormatted}</div>;
    $[6] = recentSearch.dropOffDateFormatted;
    $[7] = recentSearch.fleetTypeFormatted;
    $[8] = recentSearch.pickUpDateFormatted;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div>{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== recentSearch.linkUrl || $[14] !== t1 || $[15] !== t5) {
    t6 = <CarouselSlide as={Link} href={recentSearch.linkUrl} target="_blank" className="border-1 rounded-lg border-gray-200 w-75 h-17 flex items-center hover:shadow-sm hover:bg-gray-50 focus:shadow-sm focus:bg-gray-50 transition duration-300 ease-in-out" onClick={t1}>{t2}{t5}</CarouselSlide>;
    $[13] = recentSearch.linkUrl;
    $[14] = t1;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
}